import PropTypes from 'prop-types';
import React from 'react';
import {createPortal} from 'react-dom';
import './styles.sass';

const Overlay = ({children, blur = false, open = false}) => {
    return createPortal(
        <div data-open={open} data-blur={blur} className='az-overlay'>
            {children}
        </div>,
        document.body,
    );
};

Overlay.propTypes = {
    children: PropTypes.node,
    blur: PropTypes.bool,
    open: PropTypes.bool,
};

export default Overlay;
